// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2U2E9","list":"BalanceDue_list__3d_oQ","listRow":"BalanceDue_listRow__1vcR4","total":"BalanceDue_total__2Zttx"};